import { render, staticRenderFns } from "./ReparingOrderType.vue?vue&type=template&id=0c12a5c2&"
import script from "./ReparingOrderType.vue?vue&type=script&lang=js&"
export * from "./ReparingOrderType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports